import styled from '@emotion/styled';
import { gray02, gray05, primary } from 'presentations/views/styles/color';
import { SyntheticEvent, useRef, KeyboardEvent, useEffect } from 'react';
import TextField from 'presentations/views/components/atoms/TextField';
import Icon from 'presentations/views/components/atoms/Icon';
import IconButton from 'presentations/views/components/atoms/IconButton';
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import { isMediaMax, spacing } from 'presentations/views/styles';

interface Props {
  content: string | null;
  isDisabled?: boolean;
  isLoading?: boolean;
  onChange: (e: SyntheticEvent<HTMLInputElement>) => void;
  onSubmit: (e: SyntheticEvent<HTMLFormElement>) => void;
}

export default function Component(props: Props) {
  const t = translateInComponent([translations]);
  const formRef = useRef<HTMLFormElement>(null);
  const inputRef = useRef<HTMLFormElement>(null);
  const isMobile = isMediaMax('tablet');

  useEffect(() => {
    if (!inputRef.current) return;
    if (isMobile) return;
    inputRef.current.focus();
  }, [inputRef.current, isMobile]);

  const onKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      if (e.shiftKey) return;
      e.preventDefault();
      formRef.current?.requestSubmit();
    }
  };
  return (
    <form onSubmit={props.onSubmit} ref={formRef}>
      <SubmitForm isDisabled={props.isLoading}>
        <SubmitFormField>
          <SubmitTextField
            size="medium"
            variant="standard"
            inputRef={inputRef}
            isFullWidth
            isMultiline
            onKeyPress={onKeyPress}
            value={props.content}
            onChange={props.onChange}
            outlineColor="transparent"
            placeholder={t('Send a message')}
            isLoading={props.isLoading}
          />
        </SubmitFormField>
        <SendButton onClick={props.onSubmit} isDisabled={props.isDisabled}>
          <SendIcon
            name="send"
            isDisabled={props.isDisabled || !props.content}
          />
        </SendButton>
      </SubmitForm>
    </form>
  );
}

const SubmitForm = styled.div<{ isDisabled?: boolean }>`
  padding: ${spacing(8)} ${spacing(12)};
  display: flex;
  align-items: center;
  background-color: ${(props) => props.isDisabled && gray05};
`;
const SubmitFormField = styled.div`
  flex: 1;
`;
const SubmitTextField = styled(TextField)`
  .MuiInput-underline:before {
    border: 0;
  }
  .MuiInput-underline:after {
    border: 0;
  }
  .MuiInput-underline:before {
    border: 0 !important;
  }
  .MuiInput-underline:after {
    border: 0 !important;
  }
`;
const SendButton = styled(IconButton)``;
const SendIcon = styled(Icon)<{ isDisabled?: boolean }>`
  color: ${(props) => (props.isDisabled ? gray02 : primary)};
  width: 22px !important;
  height: 22px !important;
`;
